import { type Identifier, useGetList } from "ra-core";
import { useMemo } from "react";

import type { WorkItem } from "../types";
import { groupTasksByDeal, pickNextStep } from "./nextStep";

const NO_TASKS: WorkItem[] = [];

// Åpne oppgaver for et sett muligheter, hentet i én spørring. Gir neste steg
// (tidligste åpne oppgave med dato) per mulighet.
export const useDealTasks = (dealIds: Identifier[] | undefined) => {
  const ids = useMemo(() => [...(dealIds ?? [])], [dealIds]);
  const {
    data = NO_TASKS,
    isPending,
    refetch,
  } = useGetList<WorkItem>(
    "work_items",
    {
      filter: { deal_id: ids, "completed_at@is": null },
      sort: { field: "due_date", order: "ASC" },
      pagination: { page: 1, perPage: 1000 },
    },
    { enabled: ids.length > 0 },
  );
  const byDeal = useMemo(() => groupTasksByDeal(data), [data]);
  const nextByDeal = useMemo(() => {
    const map = new Map<string, WorkItem>();
    for (const [key, list] of byDeal) {
      const next = pickNextStep(list);
      if (next) map.set(key, next);
    }
    return map;
  }, [byDeal]);
  return {
    tasksByDeal: byDeal,
    nextByDeal,
    isPending: ids.length > 0 && isPending,
    refetch,
  };
};
